import { ElementRu } from "../types/army";
import { OpponentEntry } from "../types/marches";
import { formatNumber } from "../lib/format";
import { ElementEmblem } from "./ElementEmblem";

interface Props {
  opponents: OpponentEntry[];
  onPick: (op: OpponentEntry) => void;
  onBack: () => void;
}

export function OpponentList({ opponents, onPick, onBack }: Props) {
  return (
    <div className="flex h-full flex-col">
      <Header title="Поиск противника" onBack={onBack} />

      <div className="flex-1 space-y-2 overflow-y-auto px-3 pb-3">
        {opponents.length === 0 ? (
          <div className="rounded-xl bg-tg-secondaryBg p-4 text-center text-sm text-tg-hint">
            Противников в этом мире пока нет. Дождись других игроков или попробуй PvE.
          </div>
        ) : (
          opponents.map((op) => (
            <button
              key={op.id}
              type="button"
              onClick={() => onPick(op)}
              disabled={op.isShielded}
              className="flex w-full items-center gap-3 rounded-xl bg-tg-secondaryBg p-3 text-left disabled:opacity-50"
            >
              <ElementEmblem element={op.element} size={40} className="shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <div className="truncate font-medium">{op.displayName}</div>
                  {op.isShielded && (
                    <div className="rounded bg-tg-bg px-1.5 py-0.5 text-xs text-tg-accent">
                      под щитом
                    </div>
                  )}
                </div>
                <div className="text-xs text-tg-hint">
                  {ElementRu[op.element]} · Замок Lvl {op.castleLevel} · Сила {formatNumber(op.armyPower)}
                </div>
              </div>
              <div className="text-tg-hint">›</div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}

function Header({ title, onBack }: { title: string; onBack: () => void }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <button
        type="button"
        onClick={onBack}
        className="rounded-lg bg-tg-secondaryBg px-3 py-1.5 text-sm"
      >
        ←
      </button>
      <div className="font-medium">{title}</div>
    </div>
  );
}
